import { FC, ImgHTMLAttributes } from 'react';

const ImageDataNaplno: FC<ImgHTMLAttributes<never>> = (props) => {
  return <img src="https://cdn.o2.cz/mojeo2-product/front-end/dataNaplno.png" alt="" {...props} />;
};

export default ImageDataNaplno;
